import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=255f6077&scoped=true&"
import script from "./HeroSection.vue?vue&type=script&lang=ts&"
export * from "./HeroSection.vue?vue&type=script&lang=ts&"
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=255f6077&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255f6077",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkButton: require('/opt/build/repo/apps/shop/components/storyblok/LinkButton/LinkButton.vue').default,Video: require('/opt/build/repo/apps/shop/components/storyblok/Video/Video.vue').default})
